import React from "react";
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";

// PageHeader gives every page a compact top-left refresh button + a
// consistent title/subtitle layout. The refresh handler defaults to a
// real full-page reload (F5-equivalent) so users can escape any local
// caching / stale state in one click. Pages that want a lighter data
// refetch can still override with their own onRefresh.
export default function PageHeader({
  kicker,
  title,
  subtitle,
  onRefresh,
  refreshing,
  actions,
  border = "border-[#09090B]",
  testid,
}) {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
    // Follow up with a hard reload so the browser drops any HTTP cache,
    // in-flight axios requests, and stale local component state — the
    // ⟳ button behaves exactly like pressing F5.
    setTimeout(() => window.location.reload(), onRefresh ? 250 : 0);
  };
  return (
    <div className={`flex flex-wrap items-end justify-between gap-4 border-b-2 pb-4 ${border}`} data-testid={testid}>
      <div className="flex items-start gap-3">
        <Button
          variant="outline"
          size="icon"
          className="rounded-none border-2 border-[#09090B] h-10 w-10 shrink-0 hover:bg-[#09090B] hover:text-white"
          onClick={handleRefresh}
          disabled={refreshing}
          title="Sayfayı yenile (F5)"
          data-testid="page-refresh-btn"
        >
          <RotateCw size={16} className={refreshing ? "animate-spin" : ""} />
        </Button>
        <div>
          {kicker && (
            <div className="text-xs font-mono uppercase tracking-[0.3em] text-neutral-500">{kicker}</div>
          )}
          <h1 className="text-4xl font-black tracking-tighter font-heading">{title}</h1>
          {subtitle && <p className="text-sm text-neutral-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
